import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "size", "width", "minWidth", "maxWidth", "mask", "lazy", "placeholderChar", "preprocessInputChars", "defaultValue", "onChange", "blocks"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable import/no-named-as-default */
import * as React from 'react';
import { useEventCallback } from '@cian/react-utils';
import { FocusObserver } from '../../../internal/components/FocusObserver/FocusObserver';
import { IMaskInput } from '../../../internal/components/IMaskInput';
import { InputWrapper } from '../../../internal/components/InputWrapper/InputWrapper';
import { InputWrapperInput } from '../../../internal/components/InputWrapperInput/InputWrapperInput';
import { useControlled } from '../../../internal/hooks';
import { FocusSource } from '../../../internal/types';
import { jsx as _jsx } from "react/jsx-runtime";
const MaskedInputComponent = /*#__PURE__*/React.forwardRef(function MaskedInput(props, ref) {
  const {
      loading,
      disabled,
      invalid,
      inline,
      leftAdornment,
      rightAdornment,
      size,
      width,
      minWidth,
      maxWidth,
      mask,
      lazy = false,
      placeholderChar = '_',
      preprocessInputChars,
      defaultValue,
      onChange,
      blocks
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [value, setValue] = useControlled({
    controlled: props.value,
    default: defaultValue || ''
  });
  const [focus, setFocus] = React.useState({
    focused: false,
    source: FocusSource.mouse
  });
  const prepareOption = React.useCallback((inputChar, masked) => {
    return preprocessInputChars ? preprocessInputChars(inputChar, masked.value) : inputChar;
  }, [preprocessInputChars]);
  const options = React.useMemo(() => {
    return {
      mask,
      lazy: !focus.focused || lazy,
      placeholderChar,
      blocks,
      prepare: prepareOption
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mask, focus.focused, placeholderChar, prepareOption]);
  const handleInputAccept = useEventCallback((nextValue, mask) => {
    if (nextValue === value) {
      return;
    }
    setValue(nextValue);
    if (onChange) {
      onChange(nextValue, {
        maskedValue: mask.masked.value
      });
    }
  });
  const handleFocus = (focused, source) => {
    setFocus({
      focused,
      source
    });
  };
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    focused: focus.focused,
    focusSource: focus.source,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: leftAdornment,
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
        as: InputWrapperInput,
        disabled: disabled,
        options: options,
        onAccept: handleInputAccept,
        value: value
      }))
    })
  });
});
export const MaskedInput = /*#__PURE__*/React.memo(MaskedInputComponent);